(() => {
  const SELECTOR = 'slider-component';

  function setupDots(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    const controls = component.querySelector('.slider-buttons');

    if (!slider || !controls) return;

    let dotsContainer = controls.querySelector('.custom-slider-dots');

    if (!dotsContainer) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'custom-slider-dots';
      dotsContainer.setAttribute('role', 'group');
      dotsContainer.setAttribute('aria-label', 'Carousel navigation');
      controls.appendChild(dotsContainer);
    }

    function getSliderData() {
      const items = Array.from(
        component.querySelectorAll('[id^="Slide-"]')
      ).filter(item => item.clientWidth > 0);

      if (!items.length) {
        return {
          items: [],
          offset: 0,
          totalPages: 0,
          currentPage: 1
        };
      }

      if (items.length === 1) {
        return {
          items,
          offset: items[0].clientWidth,
          totalPages: 1,
          currentPage: 1
        };
      }

      const offset = items[1].offsetLeft - items[0].offsetLeft;

      if (!offset) {
        return {
          items,
          offset: 0,
          totalPages: items.length,
          currentPage: 1
        };
      }

      const slidesPerPage = Math.max(
        1,
        Math.floor(
          (slider.clientWidth - items[0].offsetLeft) / offset
        )
      );

      const totalPages = Math.max(
        1,
        items.length - slidesPerPage + 1
      );

      const currentPage = Math.min(
        totalPages,
        Math.max(1, Math.round(slider.scrollLeft / offset) + 1)
      );

      return {
        items,
        offset,
        totalPages,
        currentPage
      };
    }

    function updateActiveDot() {
      const { currentPage } = getSliderData();

      dotsContainer
        .querySelectorAll('.custom-slider-dot')
        .forEach((dot, index) => {
          const active = index === currentPage - 1;

          dot.classList.toggle('is-active', active);

          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
    }

    function buildDots() {
      const { totalPages, offset } = getSliderData();

      if (totalPages <= 1 || !offset) {
        dotsContainer.innerHTML = '';
        dotsContainer.hidden = true;
        return;
      }

      dotsContainer.hidden = false;

      const existingDots =
        dotsContainer.querySelectorAll('.custom-slider-dot').length;

      if (existingDots !== totalPages) {
        dotsContainer.innerHTML = '';

        for (let index = 0; index < totalPages; index++) {
          const dot = document.createElement('button');

          dot.type = 'button';
          dot.className = 'custom-slider-dot';
          dot.setAttribute(
            'aria-label',
            `Go to carousel item ${index + 1} of ${totalPages}`
          );

          dot.addEventListener('click', () => {
            const latestData = getSliderData();

            slider.scrollTo({
              left: index * latestData.offset,
              behavior: 'smooth'
            });
          });

          dotsContainer.appendChild(dot);
        }
      }

      updateActiveDot();
    }

    let scrollTimer;

    slider.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);

        scrollTimer = window.setTimeout(() => {
          updateActiveDot();
        }, 50);
      },
      { passive: true }
    );

    const resizeObserver = new ResizeObserver(() => {
      buildDots();
    });

    resizeObserver.observe(slider);

    buildDots();
  }

  function initialiseCarousels(root = document) {
    root.querySelectorAll(SELECTOR).forEach(setupDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseCarousels();
    });
  } else {
    initialiseCarousels();
  }

  /* Reinitialise when a Shopify section is reloaded
     inside the Theme Customizer */
  document.addEventListener('shopify:section:load', event => {
    initialiseCarousels(event.target);
  });
})();